import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Edit, Calendar, CalendarCheck, User, BookOpen, FileText, ClipboardList, ShieldCheck, ChevronRight } from 'lucide-react';

const EmployeeNav = ({ isHovered = true, styles = {}, onToggle }) => {
     const defaultStyles = {
          navItem: {
               display: 'flex',
               alignItems: 'center',
               padding: '8px 12px',
               color: '#111',
               textDecoration: 'none',
               gap: '8px',
               borderRadius: 6,
          },
          navItemActive: {
               backgroundColor: '#e6f0ff',
               color: '#0b63ff',
          },
          container: {
               display: 'flex',
               flexDirection: 'column',
               gap: '6px',
               padding: '8px',
               background: 'transparent',
          },
          submenuItem: {
               padding: '6px 12px',
               display: 'flex',
               alignItems: 'center',
               color: '#333',
               textDecoration: 'none',
               fontSize: '14px',
               border: 'none',
               background: 'none',
               cursor: 'pointer',
               borderRadius: 4,
          },
          submenuItemActive: {
               background: '#e6f7ff',
               color: '#1890ff',
          },
     };

     const s = {
          ...defaultStyles,
          ...styles,
     };

     const [companyPoliciesOpen, setCompanyPoliciesOpen] = useState(false);
     const baseUrl = process.env.REACT_APP_BASE_URL;

     // Read user profile from storage to determine role-specific links
     let userProfile = {};
     let isAllRenewalAllowed = false;
     try {
          const raw = sessionStorage.getItem('userProfile') || localStorage.getItem('userProfile');
          userProfile = raw ? JSON.parse(raw) : {};
          isAllRenewalAllowed = (userProfile.is_renewal || userProfile.isRenewal || '').toString().toUpperCase() === 'Y';
     } catch (err) {
          userProfile = {};
     }
     const showAssessmentLink = (userProfile.is_assessment || userProfile.isAssessment || '').toString().toUpperCase() === 'Y';
     const showRenewalLink = (userProfile.is_renewal || userProfile.isRenewal || '').toString().toUpperCase() === 'Y';

     // fetch profile data to get the employee code and use it in the attendance details link

     return (
          <div style={s.container}>
               <NavLink
                    to="/dashboard"
                    style={({ isActive }) => ({ ...s.navItem, ...(isActive ? s.navItemActive : {}) })}
               >
                    <Home size={20} />
                    {isHovered && <span style={{ marginLeft: 12 }}>Dashboard</span>}
               </NavLink>

               <NavLink
                    to="/profile"
                    style={({ isActive }) => ({ ...s.navItem, ...(isActive ? s.navItemActive : {}) })}
               >
                    <User size={20} />
                    {isHovered && <span style={{ marginLeft: 12 }}>Profile</span>}
               </NavLink>

               <NavLink
                    to="/attendance"
                    style={({ isActive }) => ({ ...s.navItem, ...(isActive ? s.navItemActive : {}) })}
               >
                    <CalendarCheck size={20} />
                    {isHovered && <span style={{ marginLeft: 12 }}>Attendance</span>}
               </NavLink>
               <NavLink
                    to="/employee-attendance-details"
                    style={({ isActive }) => ({ ...s.navItem, ...(isActive ? s.navItemActive : {}) })}
               >
                    <ClipboardList size={20} />
                    {isHovered && <span style={{ marginLeft: 12 }}>Attendance Details</span>}
               </NavLink>

               {showAssessmentLink && (
                    <>
                         <NavLink
                              to="/consultant-evaluations"
                              style={({ isActive }) => ({ ...s.navItem, ...(isActive ? s.navItemActive : {}) })}
                         >
                              <FileText size={20} />
                              {isHovered && <span style={{ marginLeft: 12 }}>Consultant Evaluations</span>}
                         </NavLink>


                    </>
               )}
               {showRenewalLink && (
                    <NavLink
                         to="/consultant-renewals"
                         style={({ isActive }) => ({ ...s.navItem, ...(isActive ? s.navItemActive : {}) })}
                    >
                         <FileText size={20} />
                         {isHovered && <span style={{ marginLeft: 12 }}>Consultant Renewals</span>}
                    </NavLink>
               )}
               {/* <NavLink
                    to="/regularize"
                    style={({ isActive }) => ({ ...s.navItem, ...(isActive ? s.navItemActive : {}) })}
               >
                    <Edit size={20} />
                    {isHovered && <span style={{ marginLeft: 12 }}>Regularize</span>}
               </NavLink> */}

               {/* Company Policies Dropdown */}
               <div>
                    <button
                         type="button"
                         style={{
                              ...s.navItem,
                              background: 'none',
                              border: 'none',
                              width: '100%',
                              textAlign: 'left',
                              display: 'flex',
                              alignItems: 'center',
                              cursor: 'pointer',
                              padding: '8px 12px',
                              color: '#333',
                         }}
                         onClick={() => setCompanyPoliciesOpen(!companyPoliciesOpen)}
                    >
                         <BookOpen size={20} />
                         {isHovered && (
                              <>
                                   <span style={{ marginLeft: 12 }}>Company Policies</span>
                                   <ChevronRight
                                        size={18}
                                        style={{
                                             marginLeft: 'auto',
                                             transition: 'transform 0.2s',
                                             transform: companyPoliciesOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                                        }}
                                   />
                              </>
                         )}
                    </button>

                    {companyPoliciesOpen && isHovered && (
                         <div style={{ paddingLeft: 32 }}>
                              <a
                                   href={`${baseUrl}/employee-document/codeOfConduct.pdf`}
                                   target="_blank"
                                   rel="noopener noreferrer"
                                   style={{
                                        ...s.submenuItem,
                                        display: 'flex',
                                        alignItems: 'center',
                                        textDecoration: 'none',
                                   }}
                              >
                                   <FileText size={16} />
                                   <span style={{ marginLeft: 8 }}>Code Of Conduct</span>
                              </a>

                              {/* Add more policy links here if needed */}
                              {/* <a
                                   href={`${baseUrl}/employee-document/privacyPolicy.pdf`}
                                   target="_blank"
                                   rel="noopener noreferrer"
                                   style={{
                                        ...s.submenuItem,
                                        display: 'flex',
                                        alignItems: 'center',
                                        textDecoration: 'none',
                                   }}
                              >
                                   <FileText size={16} />
                                   <span style={{ marginLeft: 8 }}>Privacy Policy</span>
                              </a> */}
                         </div>
                    )}
               </div>
          </div>
     );
};

export const employeeNav = (isHovered = true, styles = {}, onToggle) => {
     return <EmployeeNav isHovered={isHovered} styles={styles} onToggle={onToggle} />;
};

export default EmployeeNav;